import { UserAuthorityRole } from '@/shared/models/auth/auth-data';
import useStorage from '../use-storage';
import { useEffect, useState } from 'react';

const useCheckAccess = (requiredRole: UserAuthorityRole) => {
  const { store } = useStorage();
  const [hasAccess, setHasAccess] = useState<boolean>(false);

  useEffect(() => {
    const checkRole = async () => {
      const auth = await store.getAuth();
      const userRoles = auth?.authorities?.map((r) => r.id) || [];
      setHasAccess(userRoles.includes(requiredRole));
    };
    checkRole();
  }, [requiredRole, store]);

  return hasAccess;
};

export default useCheckAccess;
